export const SIDEBAR_EXPANDED_WIDTH_CLASS = "w-[15rem]";
export const SIDEBAR_COLLAPSED_WIDTH_CLASS = "w-[4rem]";
export const SIDEBAR_ICON_SIZE = 24;
export const NUMBER_OF_SCHEMA_DEFINITIONS_TO_LOAD = 1000;
